import { render, staticRenderFns } from "./veHqBgwpfl.vue?vue&type=template&id=6b22b11e&scoped=true"
import script from "./veHqBgwpfl.vue?vue&type=script&lang=js"
export * from "./veHqBgwpfl.vue?vue&type=script&lang=js"
import style0 from "./veHqBgwpfl.vue?vue&type=style&index=0&id=6b22b11e&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b22b11e",
  null
  
)

export default component.exports